import { getAppInstance } from '@/utils/api/app';
import { useSession } from '@zopauk/nextjs-auth';
import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse, AxiosError } from 'axios';
import type { GetMemberResponse } from '@zopauk/api-membership-hub';

export const useQueryMember = () => {
  const { data: session } = useSession();

  const memberQuery = useQuery<AxiosResponse<GetMemberResponse>, AxiosError>({
    queryFn: () => getAppInstance().get('/members/me'),
    queryKey: ['member', session?.user?.memberId],
    enabled: !!session,
  });

  return memberQuery;
};
